import { DestinationType, type MyLensesLensStatus } from "../../gql-generated/types";
import { availableEndStatusesSet } from "../../lens/state/lensStatusMap";

export const isAvailableForAds = (
    disabledDestinationTypesList: readonly DestinationType[],
    status: MyLensesLensStatus,
): boolean =>
    !disabledDestinationTypesList.includes(DestinationType.DestinationTypeAdAccount) &&
    availableEndStatusesSet.has(status);
